import React from 'react';
import { GlowingButton } from '../ui/GlowingButton';
import { motion } from 'framer-motion';
import { CheckCircle2, Timer, ShieldCheck, CreditCard, Smartphone } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="py-32 relative overflow-hidden bg-[#050505]" data-id="element-28">
      {/* Background Effects (Grid & Glow) */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] z-0" data-id="element-29" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-cyan-500/20 blur-[120px] rounded-full pointer-events-none z-0" data-id="element-30" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-31">
        <div className="max-w-4xl mx-auto text-center" data-id="element-32">
          {/* 1. URGENCY TIMER BADGE */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 font-bold tracking-widest mb-8 animate-pulse shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-33">
            <Timer className="w-5 h-5" data-id="element-34" />
            LA OFERTA EXPIRA PRONTO
          </motion.div>

          {/* 2. HEADLINE */}
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight tracking-tight" data-id="element-35">
            NO DEJES PASAR ESTA <br data-id="element-36" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 drop-shadow-[0_0_15px_rgba(6,182,212,0.3)]" data-id="element-37">
              OPORTUNIDAD ÚNICA
            </span>
          </h2>

          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto font-light" data-id="element-38">
            El precio subirá a{' '}
            <span className="text-red-400 line-through decoration-2 font-bold" data-id="element-39">
              $102
            </span>{' '}
            en cuanto termine el lanzamiento. Asegura tu acceso de por vida y
            domina esta habilidad hoy mismo.
          </p>

          {/* 3. RECAP BOX (Lo que te llevas) */}
          <div className="bg-[#0a0a0a]/80 border border-cyan-500/30 rounded-3xl p-6 md:p-8 max-w-2xl mx-auto mb-12 text-left shadow-[0_0_40px_-10px_rgba(6,182,212,0.2)] backdrop-blur-md relative overflow-hidden" data-id="element-40">
            {/* Brillo interno de la tarjeta */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-41" />

            <h3 className="text-gray-400 text-sm font-bold uppercase tracking-wider mb-4 border-b border-white/10 pb-2 relative z-10" data-id="element-42">
              RESUMEN DE TU PEDIDO:
            </h3>
            <ul className="space-y-4 relative z-10 mb-6" data-id="element-43">
              <li className="flex items-center justify-between group" data-id="element-44">
                <span className="flex items-center gap-3 text-white text-base md:text-lg font-medium" data-id="element-45">
                  <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-46" /> Masterkit
                  IA Completo
                </span>
                <span className="text-gray-500 line-through text-sm group-hover:text-white transition-colors" data-id="element-47">
                  $47
                </span>
              </li>
              <li className="flex items-center justify-between group" data-id="element-48">
                <span className="flex items-center gap-3 text-gray-300 text-sm md:text-base font-light" data-id="element-49">
                  <CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-50" /> Bono 1:
                  Biblia para Freelancers
                </span>
                <div className="text-right" data-id="element-51">
                  <span className="text-cyan-400 font-bold text-xs md:text-sm tracking-wider mr-2" data-id="element-52">
                    ¡GRATIS!
                  </span>
                  <span className="text-gray-500 line-through text-xs" data-id="element-53">
                    $27
                  </span>
                </div>
              </li>
              <li className="flex items-center justify-between group" data-id="element-54">
                <span className="flex items-center gap-3 text-gray-300 text-sm md:text-base font-light" data-id="element-55">
                  <CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-56" /> Bono 2:
                  Toolbox Anti-Bloqueos
                </span>
                <div className="text-right" data-id="element-57">
                  <span className="text-cyan-400 font-bold text-xs md:text-sm tracking-wider mr-2" data-id="element-58">
                    ¡GRATIS!
                  </span>
                  <span className="text-gray-500 line-through text-xs" data-id="element-59">
                    $19
                  </span>
                </div>
              </li>
              <li className="flex items-center justify-between group" data-id="element-60">
                <span className="flex items-center gap-3 text-gray-300 text-sm md:text-base font-light" data-id="element-61">
                  <CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-62" /> Bono 3:
                  Ruta de Monetización Rápida
                </span>
                <div className="text-right" data-id="element-63">
                  <span className="text-cyan-400 font-bold text-xs md:text-sm tracking-wider mr-2" data-id="element-64">
                    ¡GRATIS!
                  </span>
                  <span className="text-gray-500 line-through text-xs" data-id="element-65">$9</span>
                </div>
              </li>
            </ul>

            <div className="pt-6 border-t border-white/10 flex items-center justify-between relative z-10" data-id="element-66">
              <span className="text-lg md:text-xl text-gray-300 font-medium" data-id="element-67">
                Total a pagar hoy:
              </span>
              <div className="text-right" data-id="element-68">
                <span className="block text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400 drop-shadow-lg" data-id="element-69">
                  $14.99
                </span>
                <span className="block text-sm md:text-base text-cyan-400 font-bold mt-1 bg-cyan-500/10 px-2 py-1 rounded-md inline-block" data-id="element-70">
                  Aprox. Bs. 7.150
                </span>
              </div>
            </div>
          </div>

          {/* 4. FINAL CTA BUTTON */}
          <div className="flex flex-col items-center gap-6" data-id="element-71">
            <a href="https://checkout.digitalsolvex.shop/cart/43743678496856:1?checkout" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto" data-id="element-72">
              <GlowingButton variant="green" size="xl" className="w-full md:w-auto min-w-[320px] h-auto py-4 shadow-[0_0_50px_rgba(34,197,94,0.3)] hover:shadow-[0_0_80px_rgba(34,197,94,0.5)] transition-all transform hover:scale-[1.02]" data-id="element-73">
                {/* CAJA INTERNA DEL BOTÓN PARA FORZAR EL APILADO VERTICAL */}
                <div className="flex flex-col items-center justify-center w-full gap-1.5" data-id="element-74">
                  <span className="text-xl md:text-2xl font-black text-white" data-id="element-75">
                    DESCARGAR PACK AHORA
                  </span>
                  <span className="text-sm font-bold text-green-100 bg-black/20 px-4 py-1.5 rounded-full tracking-wide" data-id="element-76">
                    Paga $14.99 o Aprox. Bs. 7.150
                  </span>
                </div>
              </GlowingButton>
            </a>

            {/* Trust Elements para VENEZUELA */}
            <div className="mt-4 flex flex-col items-center gap-4 w-full" data-id="element-77">
              <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm w-full" data-id="element-78">
                <span className="flex items-center justify-center gap-2 text-green-400 bg-green-500/10 px-4 py-2 rounded-xl border border-green-500/20 flex-1 min-w-[130px] max-w-[180px]" data-id="element-79">
                  <Smartphone className="w-5 h-5" data-id="element-80" /> Pago Móvil
                </span>
                <span className="flex items-center justify-center gap-2 text-yellow-400 bg-yellow-500/10 px-4 py-2 rounded-xl border border-yellow-500/20 flex-1 min-w-[130px] max-w-[180px]" data-id="element-81">
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-82">
                    <path d="M11.999 0L17.58 5.582l-2.028 2.028-3.553-3.553-3.553 3.553-2.028-2.028L11.999 0zm0 16.516l-4.516-4.516-2.028 2.028 6.544 6.544 6.544-6.544-2.028-2.028-4.516 4.516zm9.58-10.934l2.028 2.028-6.544 6.544-2.028-2.028 6.544-6.544zm-19.16 0l2.028-2.028 6.544 6.544-2.028 2.028-6.544-6.544z" data-id="element-83" />
                  </svg>{' '}
                  Binance Pay
                </span>
                <span className="flex items-center justify-center gap-2 text-blue-400 bg-blue-500/10 px-4 py-2 rounded-xl border border-blue-500/20 flex-1 min-w-[130px] max-w-[180px]" data-id="element-84">
                  <CreditCard className="w-5 h-5" data-id="element-85" /> Tarjetas
                </span>
              </div>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500 opacity-90 mt-2 bg-white/5 px-6 py-3 rounded-full" data-id="element-86">
                <span className="flex items-center gap-2" data-id="element-87">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-88" /> Garantía
                  Blindada de 7 días
                </span>
                <span className="hidden md:block text-white/20" data-id="element-89">•</span>
                <span className="flex items-center gap-2" data-id="element-90">
                  <CheckCircle2 className="w-4 h-4 text-cyan-500" data-id="element-91" /> Entrega
                  Inmediata al Correo
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}